import React from 'react';
import { CalenderMarkersCalendarDisplay, parseCalenderMarkers } from '../../utils/calenderMarkerUtils';
import { useI18n } from '../../utils/i18n';

// #604: Kopfzeile eines Ticketblocks in den drei Kalendern (Woche, „Alle
// Kalender“, Tagesleiste). Ganz rechts der Prioritätspunkt, nur bei hoch
// (gelb) und kritisch (rot), links davon die Kalendermarker und das
// Teams-Symbol. Die Farbe des Blocks sagt nichts mehr über die Priorität, sie
// unterscheidet nur noch Standard und „Gebucht“ (utils/kalenderHelfer.getTicketColor).
//
// Vorher lagen Marker und Teams-Symbol beide absolut oben rechts, das
// Teams-Symbol verdeckte die Marker.


export function prioritaetsPunkt(priority) {
  return priority === 'kritisch' || priority === 'hoch' ? priority : null;
}

export function istTeamsTicket(ticket) {
  try {
    return /https?:\/\/(.*\.)?teams\.microsoft\.com/i.test(String(ticket?.description || ''));
  } catch (_) {
    return false;
  }
}

/** Steht oben rechts etwas? Dann weicht das 🎫 (`.has-markers` in App.css). */
export function hatKennung(ticket) {
  return !!prioritaetsPunkt(ticket?.priority) || istTeamsTicket(ticket)
    || (ticket?.calenderMarker ? parseCalenderMarkers(ticket.calenderMarker).length > 0 : false);
}

/**
 * Platz rechts im Block (paddingRight): 24px mit Markern oder Teams, wie vor
 * #604, sonst 4px. Der Punkt allein bekommt keinen Platz, er liegt über der
 * Kopfzeile wie früher das 🎫. In „Alle Kalender“ sind die Spalten so schmal,
 * dass schon 16px den Text zu einer Buchstabenreihe zusammendrücken.
 */
export function kennungPlatz(ticket) {
  const marker = ticket?.calenderMarker ? parseCalenderMarkers(ticket.calenderMarker).length : 0;
  return marker > 0 || istTeamsTicket(ticket) ? '24px' : '4px';
}

export default function KalenderTicketKennung({ ticket }) {
  const { t } = useI18n();
  const punkt = prioritaetsPunkt(ticket?.priority);
  const marker = ticket?.calenderMarker ? parseCalenderMarkers(ticket.calenderMarker) : [];
  const teams = istTeamsTicket(ticket);
  if (!hatKennung(ticket)) return null;
  const prioText = punkt === 'kritisch'
    ? t('ticket.priority.critical', 'Kritisch')
    : t('ticket.priority.high', 'Hoch');
  return (
    <div className="kalender-kennung">
      {marker.length > 0 && <CalenderMarkersCalendarDisplay markers={ticket.calenderMarker} inline />}
      {teams && (
        <span className="kalender-kennung-symbol" title={t('eventDetail.teamsMarker', 'Teams-Besprechung')}>🎥</span>
      )}
      {punkt && (
        <span
          className={`prio-punkt prio-punkt--${punkt}`}
          role="img"
          aria-label={`${t('ticketDetail.priority', 'Priorität')}: ${prioText}`}
          title={`${t('ticketDetail.priority', 'Priorität')}: ${prioText}`}
        />
      )}
    </div>
  );
}
